import {
  NativeStackNavigationProp,
  createNativeStackNavigator,
} from "@react-navigation/native-stack";
import {
  UserLoggedInNavigatorNavigationProp,
  UserLoggedInNavigatorParamList,
} from "../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";

type RoutineOccasionStackRoutes = {
  RoutineOccasionMain: UserLoggedInNavigatorParamList["RoutineOccasion"];
};
export const RoutineOccasionStack =
  createNativeStackNavigator<RoutineOccasionStackRoutes>();

export type RoutineOccasionNavigationProp<
  T extends keyof RoutineOccasionStackRoutes,
> = CompositeNavigationProp<
  UserLoggedInNavigatorNavigationProp<"RoutineOccasion">,
  NativeStackNavigationProp<RoutineOccasionStackRoutes, T>
>;

export type RoutineOccasionRouteProp<
  T extends keyof RoutineOccasionStackRoutes,
> = RouteProp<RoutineOccasionStackRoutes, T>;

export type RoutineOccasionScreenProps<
  T extends keyof RoutineOccasionStackRoutes,
> = {
  navigation: RoutineOccasionNavigationProp<T>;
  route: RoutineOccasionRouteProp<T>;
};
